import React, { useState } from 'react';
import Slider, { Settings } from 'react-slick';
import { Booth } from '../../../../../interfaces/interfaces';
import VideoElement from './VideoElement';

interface BoothVideosProps extends React.HTMLAttributes<HTMLDivElement> {
  booth: Booth;
}

const BoothVideos = ({ booth }: BoothVideosProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const settings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  if (!booth.boothVideos) return <></>;
  return (
    <div className="h-full content-center w-full">
      <Slider afterChange={setCurrentIndex} {...settings}>
        {booth.boothVideos.map((bVideo, index) => (
          <VideoElement currentIndex={currentIndex} visible={index === currentIndex} key={bVideo.video} welcomeVideo={bVideo} />
        ))}
      </Slider>
    </div>
  );
};

export default BoothVideos;
